<template>
  <div class="setup-hub-sidebar-header">
    <div class="d-flex align-center justify-space-between mb-5">
      <div class="d-flex align-center">
        <v-icon icon="$setupHub" size="24" />
        <div class="headline6 text-white">{{ $t("setupHub.title") }}</div>
      </div>
      <v-icon icon="$minimizeXs" size="24" class="cursor-pointer" @click="closeSidebar()" />
    </div>

    <div class="d-flex align-center w-100">
      <v-progress-linear
        color="green-base"
        :model-value="completedSteps"
        :max="totalSteps"
        rounded
      />

      <div class="ml-4 subtitle2 text-white">{{ completedSteps }}/{{ totalSteps }}</div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useSetupHubStore } from "@/_store/setup-hub.module.ts";
import { storeToRefs } from "pinia";
import { useSidebarPanelStore } from "@/_store/sidebar-panel.module.ts";
import { trackGtmEvent } from "@/_helpers/utils.ts";
import { GtmAction, GTMParams } from "@/constants/gtm.ts";

export default defineComponent({
  setup() {
    const setupHubStore = useSetupHubStore();
    const { totalSteps, completedSteps } = storeToRefs(setupHubStore);
    const closeSidebar = () => {
      trackGtmEvent(GtmAction.SETUP_HUB, GTMParams.CLOSED);
      useSidebarPanelStore().closeSidebar();
    };

    return {
      totalSteps,
      completedSteps,
      closeSidebar,
    };
  },
});
</script>

<style scoped lang="scss">
.setup-hub-sidebar-header {
  width: 400px;
  background-color: rgb(var(--v-theme-indigo-purple));
  padding: 24px 16px;
}

.icon-minimize-xs::before {
  color: rgb(var(--v-theme-white));
}

.icon-protection-xs::before {
  color: rgb(var(--v-theme-white));
}
</style>
